export default __webpack_public_path__ + "images/share-alt-solid_db73c0.svg";